import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/lib/Alert';
import { CSSTransition } from 'react-transition-group';

export default class AlertMessage extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    messageType: PropTypes.string,
    timeout: PropTypes.bool,
    visible: PropTypes.bool,
    onAlertDismiss: PropTypes.func,
    clearMessages: PropTypes.func,
    manualDismiss: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.dismissAlert = this.dismissAlert.bind(this);
    this.manualDismissFunc = this.manualDismissFunc.bind(this);
    this.state = { alertVisible: true };
  }

  static defaultProps = {
    timeout: true,
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.manualDismiss && nextProps.message && !this.timeout) {
      this.timeout = setTimeout(this.dismissAlert, 4000);
      this.setState({ alertVisible: true });
    }
  }

  componentDidMount() {
    if (!this.props.manualDismiss) {
      setTimeout(this.dismissAlert, 4000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  dismissAlert() {
    this.timeout = null;
    this.setState({ alertVisible: false });
    if (typeof this.props.clearMessages === 'function') {
      this.props.clearMessages();
    }
  }

  manualDismissFunc() {
    if (typeof this.props.clearMessages === 'function') {
      this.props.clearMessages();
    }

    if (typeof this.props.onAlertDismiss === 'function') {
      this.props.onAlertDismiss();
    }
  }

  render() {
    if (this.props.manualDismiss) {
      if (this.props.message) {
        return (
          <Alert bsStyle={this.props.messageType} onDismiss={this.manualDismissFunc}>
            <strong>{this.props.message}</strong>
          </Alert>
        );
      } else {
        return null;
      }
    } else {
      const onDismissFunc = this.props.timeout
        ? null
        : this.props.onAlertDismiss
          ? this.props.onAlertDismiss
          : this.dismissAlert;

      if (this.props.visible && this.state.alertVisible) {
        return (
          <CSSTransition classNames="alert-transition" timeout={1000}>
            <Alert bsStyle={this.props.messageType} onDismiss={onDismissFunc}>
              <strong>{this.props.message}</strong>
            </Alert>
          </CSSTransition>
        );
      } else {
        return null;
      }
    }
  }
}
